export default __webpack_public_path__ + "static/media/gallery - story - bard (1)_00.4f2716d6.jpg";